module.exports = __webpack_public_path__ + "img/pc_banner.da7e8115.jpg";